import React from 'react'
import TraumaDrawer from '../../components/drawers/trauma'
import BilledQueue from '../../components/pages/billedQueue'

const Queue = () => {
    return (
        <BilledQueue
            category="Trauma"
            basePath="/app/trauma/queue"
            DrawerComponent={TraumaDrawer}
            includeReportsMenu
            usePresetRanges={false}
        />
    )
}

export default Queue
